import { CHANGE_LANGUAGE } from './types';

export const changeLang = (lang) => dispatch => {
  dispatch({
    type: CHANGE_LANGUAGE,
    payload: lang
  })
};


export const getFinancialMapData = () => dispatch => {


  // dispatch({
  //   type: CHANGE_LANGUAGE,
  //   payload: lang
  // })
};


